import React from "react";
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar,
} from "./Portlet";
const ContentLayout = ({ children, toolbar, showHeader = false }) => {
  return (
    <React.Fragment>
      <Portlet className="portlet-height" style={{ marginBottom: "0px" }}>
        {showHeader ? (
          <PortletHeader
            toolbar={
              typeof toolbar !== "undefined" ? (
                <React.Fragment>
                  <PortletHeaderToolbar>{toolbar}</PortletHeaderToolbar>
                </React.Fragment>
              ) : null
            }
          />
        ) : null}

        <PortletBody>{children}</PortletBody>
      </Portlet>
    </React.Fragment>
  );
};

export default ContentLayout;
